module.exports = __webpack_public_path__ + "img/EO.2ae3bda2.png";